import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

// RepositoryLayout — the shell for the Repository workflow (approved IA §5): browse and maintain
// Season Manager's own curated operational-season data. It owns the section header, the child
// navigation and page framing; the feature components rendered through <Outlet /> own their grids,
// editing, dialogs, data loading and API calls.
//
// Seasons (the operational-season records) and Franchise Calendars (their per-year organization) are
// peers on the same pipeline, so they are siblings here rather than parent/child.
export default function RepositoryLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = location.pathname.includes("/repository/franchise-calendars") ? "calendars" : "seasons";
  const handleChange = (event, next) => {
    navigate(next === "calendars" ? "/repository/franchise-calendars" : "/repository/seasons");
  };

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Box sx={{ mt: 1, mb: 0.5 }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Repository
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Browse and maintain approved operational-season data.
        </Typography>
      </Box>

      <Tabs
        value={activeTab}
        onChange={handleChange}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}
      >
        <Tab label="Seasons" value="seasons" />
        <Tab label="Franchise Calendars" value="calendars" />
      </Tabs>

      <Outlet />
    </Box>
  );
}
